<template>
  <v-row>
    <v-col cols="12" sm="8" md="6" class="d-flex align-center">
      <p class="d-inline form__title primary--text pr-2 mb-0">
        {{ title }}
      </p>
      <BaseButton icon @click="showDataTable()">
        <v-icon color="secondary" size="14"> {{ iconShowDataTable }} </v-icon>
      </BaseButton>
    </v-col>
    <v-spacer />
    <v-col cols="12" sm="4" md="3">
      <BaseButton
        class="white--text secondary"
        width="100%"
        @click="openFormContacts"
      >
        <v-icon class="pr-2">
          fa-plus
        </v-icon>
        INCLUIR CONTATO
      </BaseButton>
    </v-col>
    <v-col cols="12" class="pt-4" v-if="isActiveTable">
      <BaseDataTable
        :headers="header"
        :items="list"
        hide-default-footer
        class="insurance-company-table"
        @click:row="editItem"
      >
        <!-- Não posso usar o click:row, por causa do botão -->
        <!-- Assim terei que colocar click por template -->
        <!-- Já que o cliente deseja este tipo de interação -->
        <template v-slot:[`item.nome`]="{ item }">
          <div :class="borderColor(item.ativo)">
            <div class="insurance-company-table__padding">
              {{ item.nome }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <BaseButton
            color="secondary"
            class="px-0 form__button-data-table"
            @click.stop="removeItemList(item)"
          >
            <img :src="require('@/assets/ic_trash.svg')" />
          </BaseButton>
        </template>
      </BaseDataTable>
      <div v-if="errorMessages.length > 0" class="v-text-field__details mt-4">
        <div class="v-messages theme--light error--text" role="alert">
          <div class="v-messages__wrapper">
            <div
              v-for="(message, index) in errorMessages"
              :key="`error-message-${index}`"
              class="v-messages__message"
            >
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col cols="12" class="pb-7 pt-10">
      <v-divider />
    </v-col>
  </v-row>
</template>
<script>
const tableHeaders = [
  { text: "Nome", value: "nome", sortable: true },
  { text: "E-mail", value: "email", sortable: true },
  { text: "Comercial", value: "telefone1", sortable: true },
  { text: "Celular", value: "telefone2", sortable: true },
  { text: "Departamento/Cargo", value: "departamento", sortable: true },
  { text: "", value: "id", sortable: false }
];
const colorByStatus = [
  { color: "green", status: true },
  { color: "pink", status: false }
];
export default {
  data: () => ({
    isActiveTable: true,
    header: tableHeaders,
    listColorByStatus: colorByStatus
  }),
  computed: {
    iconShowDataTable() {
      return this.isActiveTable ? "fa-chevron-up" : "fa-chevron-down";
    }
  },
  methods: {
    showDataTable() {
      this.isActiveTable = !this.isActiveTable;
    },
    removeItemList(item) {
      this.$emit("remove", item);
    },
    openFormContacts() {
      this.$emit("open");
    },
    editItem(item) {
      this.$emit("edit", item);
    },
    borderColor(item) {
      const status = this.listColorByStatus.find(x => x.status == item);
      return `insurance-company-table__border-${status.color}`;
    }
  },
  props: {
    title: {
      type: String
    },
    list: {
      type: Array
    },
    errorMessages: {
      type: Array
    }
  }
};
</script>
<style lang="sass">
.insurance-company-table__
  &border-green
    border-left: 5px solid #49DCBB
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.insurance-company-table
  tbody tr
    cursor: pointer
.insurance-company-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
</style>
